var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgArrowRight5 = function SvgArrowRight5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.311 14.774a.977.977 0 01-1.524.112l-.09-.095a1.12 1.12 0 01-.108-1.382l4.452-5.443L.59 2.59a1.12 1.12 0 01.108-1.38l.09-.096a.977.977 0 011.524.111L7.395 7.32c.274.383.274.911 0 1.294l-5.084 6.161z",
    fill: "currentColor"
  })));
};
export default SvgArrowRight5;